'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Cell_web = require('../../../atoms/Cell/Cell.web.cjs');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
var Info_web_styles = require('./Info.web.styles.cjs');

/**
 *  Description added in ProductCard.web.tsx
 */ const Info = ({ name, typographyStyleOverride = "h5", isDoubleLine = false, brandOrAuthor, description, isLoading = false })=>{
    const nameStyles = [
        typographyStyleOverride === "h4" && Info_web_styles.name.h4,
        typographyStyleOverride === "h5" && (isDoubleLine ? Info_web_styles.name.h5Double : Info_web_styles.name.h5),
        brandOrAuthor && isLoading && Info_web_styles.skeletonName
    ];
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: Info_web_styles.wrapper,
        children: [
            /*#__PURE__*/ jsxRuntime.jsxs("div", {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("div", {
                        css: nameStyles,
                        "data-testid": "name-wrapper",
                        children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                            type: "body",
                            styleOverride: typographyStyleOverride,
                            isMarginless: true,
                            title: name,
                            isLoading: isLoading,
                            children: name
                        })
                    }),
                    brandOrAuthor && /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                        type: "body",
                        isMarginless: true,
                        title: brandOrAuthor,
                        customCss: Info_web_styles.brand,
                        isLoading: isLoading,
                        children: brandOrAuthor
                    })
                ]
            }),
            description && /*#__PURE__*/ jsxRuntime.jsx(Cell_web.Cell, {
                backgroundColor: "system",
                customCss: Info_web_styles.cell,
                children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                    type: "footnote",
                    isLoading: isLoading,
                    children: description
                })
            })
        ]
    });
};

exports.Info = Info;
//# sourceMappingURL=Info.web.cjs.map
